import type { OnboardingAnswers, OnboardingInput } from '~/types/onboarding';
import { ONBOARDING_STATUS_COMPLETED } from '~/types/onboarding';

/**
 * Wizard-required preference answers (excludes optional company_size).
 */
export function isOnboardingPreferencesComplete(
  answers: OnboardingAnswers
): boolean {
  return (
    Boolean(answers.industryId) &&
    answers.applicationIds.length > 0 &&
    Boolean(answers.customerGroupId) &&
    Boolean(answers.buyingJourneyPhase) &&
    Boolean(answers.jobPositionId)
  );
}

/**
 * Portal save: promote to `completed` when preferences are complete and the
 * current status is not already completed. Returns `undefined` to omit the
 * status field (no downgrade, incomplete saves leave status unchanged).
 */
export function resolvePortalOnboardingStatus(
  answers: OnboardingAnswers,
  currentStatus?: string | null
): OnboardingInput['cp_onboarding_status'] | undefined {
  if (!isOnboardingPreferencesComplete(answers)) {
    return undefined;
  }

  if (currentStatus === ONBOARDING_STATUS_COMPLETED) {
    return undefined;
  }

  return ONBOARDING_STATUS_COMPLETED;
}
